import React from 'react';
import './ImageCard.css';
import { useInView } from 'react-intersection-observer';

function ImageCard({ image, onClick, cache }) {
  const { ref, inView } = useInView({ triggerOnce: true });

  // Use image.thumbSrc if available, otherwise fallback to image.src
  const thumbSrc = image.thumbSrc || image.src;

  return (
    <div ref={ref} className="image-card" onClick={onClick}>
      <div className="image-container">
        {inView || (cache && cache.has(thumbSrc)) ? (
          <img src={thumbSrc} alt={image.alt || ''} />
        ) : (
          <div className="placeholder" />
        )}
      </div>
    </div>
  );
}

export default ImageCard;